import { render, staticRenderFns } from "./AddHeadline.vue?vue&type=template&id=4a148f4c&scoped=true"
import script from "./AddHeadline.vue?vue&type=script&lang=js"
export * from "./AddHeadline.vue?vue&type=script&lang=js"
import style0 from "./AddHeadline.vue?vue&type=style&index=0&id=4a148f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a148f4c",
  null
  
)

export default component.exports